// extracted by mini-css-extract-plugin
module.exports = {"component":"slider-toggle-component--3xDCn"};